<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFirefoxLogo_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M15.871 2.436a.417.417 0 0 0-.354.744c1.658 1.127 2.67 4.146 2.734 6.514a5.438 5.438 0 0 0-1.565-1.833.417.417 0 0 0-.583.583 4.583 4.583 0 0 1-3.685 7.306 3.42 3.42 0 0 1-1.365-.217 7.337 7.337 0 0 0 1.351-.734 3.363 3.363 0 0 1 1.68-.716.417.417 0 0 0 .405-.517 1.635 1.635 0 0 0-1.654-1.15 1.416 1.416 0 0 0-1.077.428c-.224.2-.455.406-1.423.406-1.704 0-2.5-.994-2.5-1.666a.865.865 0 0 1 .365-.62c.185-.13.383-.242.59-.333a.43.43 0 0 0 .59 0 .982.982 0 0 0 .206-.964l2.23-1.486a.417.417 0 0 0-.23-.763h-.834c-.927 0-1.534-.18-1.666-.494-.191-.46.437-1.44 1.125-2.127a.417.417 0 0 0-.292-.712 3.551 3.551 0 0 0-2.676 1.627 8.96 8.96 0 0 0-1.886.029 2.179 2.179 0 0 1-.333-.5 4.345 4.345 0 0 1-.52-1.573.417.417 0 0 0-.712-.295 3.29 3.29 0 0 0-.642 3.559C.581 11.82 2.46 17.865 7.349 20.434a9.998 9.998 0 0 0 4.653 1.148C17.608 21.582 22 17.372 22 12v-.833c0-5.082-3.166-7.842-6.129-8.73Z"
    />
</svg>
